import Alpine from 'alpinejs'
Alpine.start()
import './fancybox';

console.debug('hello!');

// Toggle dropdown
const hamburgerButton = document.getElementById('hamburger');
const closeButtons = document.getElementsByClassName('close');
const firstLevelMenu = document.getElementById('first-level-menu');
const subMenuButton = document.getElementById('open-submenu-arrow');
const secondLevelMenu = document.getElementById('second-level-menu');
const closeSubmenuButton = document.getElementById('close-submenu-arrow');

if (hamburgerButton) {
  hamburgerButton.addEventListener('click', () => {
    firstLevelMenu.classList.toggle('open');
  });

  if(closeSubmenuButton){
    closeSubmenuButton.addEventListener('click', () => {
      secondLevelMenu.classList.toggle('open');
    });
  }

  Array.from(closeButtons).forEach(function (element) {
    element.addEventListener('click', () => {
      firstLevelMenu.classList.remove('open');
      secondLevelMenu.classList.remove('open');
    });

    element.addEventListener('keyup', (e: any) => {
      if (e.code === 'Enter') {
        firstLevelMenu.classList.remove('open');
        secondLevelMenu.classList.remove('open');
      }
    });
  });
}
let width = document.body.clientWidth;

if (width < 900) {
  subMenuButton.addEventListener('click', () => {
    secondLevelMenu.classList.toggle('open');
  });
} else {
  subMenuButton.addEventListener('keyup', (e: any) => {
    if (e.code === 'Enter') {
      secondLevelMenu.classList.toggle('openAccess');
    }
  });
}
document.onkeydown = (evt) => {
  if (evt.code === 'Escape' && secondLevelMenu.classList.contains('open')) {
    secondLevelMenu.classList.remove('openAccess');
  }
};

const onresize = () => {
  width = document.body.clientWidth;
};
window.addEventListener('resize', onresize);
